<!-- ========================================================================================
      Author: Mahdavi
========================================================================================== -->

<!-- <template src="./Bills.html">-->
<template>
  <vs-popup
    class="holamundo"
    popup-class="w-9/12"
    title="انتخاب بازاریاب"
    :active.sync="popupActive"
  >
    <vx-card class="mb-2">
      <div class="vx-row mb-2">
        <div class="vx-col w-full ml-5">
          <div class="vx-row mb-2">
            <div class="vx-col sm:w-8/12 flex-inline">
              <vs-input
                v-model="filter"
                class="w-full"
                label-placeholder="شماره همراه(09123456789)"
                @keyup.enter="
                  pageNo = 1;
                  getData();
                "
              />
            </div>
            <div class="vx-col sm:w-2/12 flex-inline pt-4">
              <vs-button
                @click="
                  pageNo = 1;
                  getData();
                "
                class="mx-3"
                color="primary"
                type="filled"
                icon-pack="feather"
                icon="icon-search"
                >جستجو</vs-button
              >
            </div>
          </div>
        </div>
      </div>
    </vx-card>
    <vx-card class="mb-2">
      <vs-table
        id="tbl2"
        ref="tbl2"
        :data="promoters"
        class="table-dark-inverted"
        @selected="selected"
      >
        <template slot="header">
          <div class="vx-row mb-2 w-full">
            <div class="vx-col sm:w-2/3 flex-inline">
              <div class="vx-row mb-2">
                <div class="vx-col">
                  <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                      <div
                        class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                      >
                        <span class="mr-2">
                          {{ (pageNo - 1) * pageSize + 1 }}
                          -
                          {{
                            pageNo * pageSize > totalCount
                              ? totalCount
                              : pageNo * pageSize
                          }}
                          از {{ totalCount }}
                        </span>
                        <feather-icon
                          icon="ChevronDownIcon"
                          svgClasses="h-4 w-4"
                        />
                      </div>
                      <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                      <vs-dropdown-menu>
                        <vs-dropdown-item @click="SetPageSize(5)">
                          <span>5</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(10)">
                          <span>10</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(20)">
                          <span>20</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(50)">
                          <span>50</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(100)">
                          <span>100</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(150)">
                          <span>150</span>
                        </vs-dropdown-item>
                      </vs-dropdown-menu>
                    </vs-dropdown>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template slot="thead">
          <vs-th>کد</vs-th>
          <vs-th>نام </vs-th>
          <vs-th>شماره همراه</vs-th>
          <vs-th></vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <span>{{ tr.id }}</span>
            </vs-td>
            <vs-td>
              <span>{{ tr.firstName }} {{ tr.lastName }}</span>
            </vs-td>
            <vs-td>
              <span>{{ tr.userName }}</span>
            </vs-td>
            <vs-td>
              <a @click="unassign(tr.userId)" v-if="tr.selected">لغو</a>
              <a @click="assign(tr.userId)" v-else>انتخاب</a>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <paginate
        v-model="pageNo"
        :page-count="pagesCount"
        :click-handler="getData"
      />
    </vx-card>
  </vs-popup>
</template>
<style>
.nav-transacttions > .vs-popup {
  width: 100%;
}
</style>
<script>
export default {
  name: "select-promoter",
  data() {
    return {
      promoters: [],
      totalCount: 1,
      pageSize: 10,
      pagesCount: 1,
      pageNo: 1,
      filter: "",
      popupActive: false,
      merchantUserId: null,
      draftId: null,
    };
  },
  computed: {},
  methods: {
    getData() {
      let loading = this.$vs.loading();
      let payload = {
        params: {
          MaxResultCount: this.pageSize,
          SkipCount: this.pageSize * (this.pageNo - 1),
          Filter: this.filter,
          merchantUserId:this.merchantUserId,
          draftId:this.draftId
        },
      };
      let path=this.merchantUserId?'GetAllForMerchant':'GetAllForDraft';
      this.$http
        .get(`/api/services/app/Promoters/${path}`, payload)
        .then((response) => {
          this.promoters = response.data.result.items;
          this.totalCount = response.data.result.totalCount;
          this.pagesCount = Math.ceil(this.totalCount / this.pageSize);
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close();
        }); //end http
    },
    SetPageSize(val) {
      this.pageSize = val;
      this.pageNo = 1;
      this.getData();
    },
    assign(userId) {
        this.$emit("assign", userId);
        this.popupActive=false;
    },
    unassign(userId) {
        this.$emit("unassign", userId);
        this.popupActive=false;
    },
    selected(tr) {
      //this.showTransaction(tr.transaction.id);
    },
    show(merchantUserId,draftId, title) {
      this.merchantUserId = merchantUserId;
      this.draftId = draftId;
      this.popupActive = true;
      this.getData();
    },
  },
  mounted() {},
};
</script>
